export const pushEcommerce = (data) => {
  try {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push(data);
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerAddToCart = (
  gtmEcommerceItems,
  email,
  click_source
) => {
  try {
    pushEcommerce({
      event: 'gtm_add_to_cart',
      ecommerce: {
        items: gtmEcommerceItems,
        currency: gtmEcommerceItems[0].currency,
        value: gtmEcommerceItems.reduce(
          (p, v) => p + v.price * v.quantity,
          0
        ),
      },
      snap: {
        category: gtmEcommerceItems[0].item_category,
        itemIds: gtmEcommerceItems.map((i) => i.item_id).join(','),
        nrOfItems: gtmEcommerceItems.length,
        userEmail: email,
      },
      click_source,
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerGtmViewCart = (cart) => {
  try {
    pushEcommerce({
      event: 'gtm_view_cart',
      ecommerce: {
        currency: cart.currency,
        value: cart.gtmGrandTotal,
        items: cart.gtmOrderRows,
      },
    });
  } catch (e) {
    console.log(e);
  }
};

const buildCartEcommerce = (cart) => {
  const orderRows = Array.isArray(cart?.orderRows) ? cart.orderRows : [];
  const items = orderRows.reduce((result, row) => {
    if (!row?.gtmEcommerceItem) return result;

    result.push({
      ...row.gtmEcommerceItem,
      quantity: row.quantity,
      index: result.length,
    });
    return result;
  }, []);

  return {
    currency: items.find((item) => item.currency)?.currency || '',
    value: cart?.gtmGrandTotal || 0,
    items,
  };
};

export const dataLayerGtmSelectItem = (item) => {
  try {
    if (!item) return;

    pushEcommerce({
      event: 'gtm_select_item',
      ecommerce: {
        item_list_id: item.item_list_id,
        item_list_name: item.item_list_name,
        items: [item],
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerGtmRemoveFromCart = (item, quantity) => {
  try {
    if (!item || quantity <= 0) return;

    pushEcommerce({
      event: 'gtm_remove_from_cart',
      ecommerce: {
        currency: item.currency || '',
        value: (item.price || 0) * quantity,
        items: [{ ...item, quantity }],
      },
    });
  } catch (e) {
    console.log(e);
  }
};

// Tracked values per checkout step, so each shipping tier / payment type is pushed once per page load.
const trackedCheckoutSteps = {};

const pushCheckoutStep = (event, cart, key, extra) => {
  const ecommerce = buildCartEcommerce(cart);
  const trackedKeys = (trackedCheckoutSteps[event] = trackedCheckoutSteps[event] || new Set());
  if (ecommerce.items.length === 0 || trackedKeys.has(key)) return;

  trackedKeys.add(key);
  pushEcommerce({
    event,
    ecommerce: {
      ...ecommerce,
      ...extra,
    },
  });
};

export const dataLayerGtmAddShippingInfo = (cart, shippingTier) => {
  try {
    pushCheckoutStep('gtm_add_shipping_info', cart, shippingTier, {
      shipping_tier: shippingTier,
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerGtmAddPaymentInfo = (cart, paymentType) => {
  try {
    pushCheckoutStep('gtm_add_payment_info', cart, paymentType, {
      payment_type: paymentType,
    });
  } catch (e) {
    console.log(e);
  }
};

// Called when the shopper submits the order (place order button or payment widget purchase).
// Falls back to the selected delivery method if no shipping step was tracked earlier.
export const dataLayerGtmCheckoutSubmitted = (cart, checkoutPayload) => {
  try {
    const { selectedDeliveryMethod, selectedPaymentMethod } = checkoutPayload || {};
    if (!trackedCheckoutSteps['gtm_add_shipping_info']?.size && selectedDeliveryMethod?.name) {
      dataLayerGtmAddShippingInfo(cart, selectedDeliveryMethod.name);
    }
    if (selectedPaymentMethod?.name) {
      dataLayerGtmAddPaymentInfo(cart, selectedPaymentMethod.name);
    }
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerGtmSignUp = ({ email }) => {
  try {
    pushEcommerce({
      event: 'sign_up',
      snap: {
        userEmail: email,
      },
    });
  } catch (e) {
    console.log(e);
  }
};
